import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "@/App";
import "./index.scss";

if (import.meta.env.VITE_CURRENT_ENV === "production") {
	Sentry.init({
		dsn: "https://78617b53be8c4dcbaed51be11cac6fc8@sentry.robustastudio.com/26",
		environment: import.meta.env.VITE_CURRENT_ENV,
		integrations: [new Sentry.BrowserTracing()],
		tracesSampleRate: 0.2,
	});
}

console.log(
	"[cgr] pipeline smoke test — build env:",
	import.meta.env.VITE_CURRENT_ENV,
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
